import PoweredByJusto from '@components/PoweredByJusto'
import Layout from '@components/V3/Layout'
import useScreenSize from '@hooks/useScreenSize'
import useIsAnalyticsV2Avail from '@page-components/AnalyticsV2/hooks/useIsAnalyticsV2Available'
import TrackCheckoutPageView from '@page-components/AnalyticsV2/tracking-components/TrackCheckoutPageView'
import dynamic from 'next/dynamic'
import React from 'react'

import Divider from '../../components/V3/Divider'

import TrackPageView from './TrackPageView'
import CheckoutV3ContextProvider from './components/CheckoutV3ContextProvider'
import PreferencesCleaner from './components/PreferencesCleaner'
import CouponSkeleton from './sections/Coupon/Skeleton'
import LogoSkeleton from './sections/Logo/Skeleton'
import Main from './sections/Main'
import PaymentSkeleton from './sections/Payment/Skeleton'
import Upselling from './sections/Upselling'
import WebsiteCoinsSkeleton from './sections/WebsiteCoins/Skeleton'

const Logo = dynamic(() => import('./sections/Logo'), {loading: () => <LogoSkeleton />})
const Coupon = dynamic(() => import('./sections/Coupon'), {loading: () => <CouponSkeleton />})
const Payment = dynamic(() => import('./sections/Payment'), {
  loading: () => <PaymentSkeleton />,
})
const WebsiteLoyaltyProgram = dynamic(() => import('./sections/WebsiteCoins'), {
  loading: () => <WebsiteCoinsSkeleton />,
})

const JustoCoinsProgram = dynamic(() => import('./sections/JustoCoins'), {
  loading: () => null,
})
const LoyaltyProgram = dynamic(() => import('./sections/LoyaltyProgram')) // No Skeleton since most countries won't show it
const Page = dynamic(() => import('@page-components/Page'), {ssr: false})

export default function CheckoutV3() {
  const screenSize = useScreenSize()
  const isAnalyticsV2Avail = useIsAnalyticsV2Avail()
  return (
    <CheckoutV3ContextProvider>
      <Layout
        sidebarWidth="sm"
        sidebar={
          <>
            {['mobile', 'sm'].includes(screenSize) ? null : (
              <>
                <Coupon />
                <Divider className="mb-4" />
              </>
            )}
            <JustoCoinsProgram />
            <WebsiteLoyaltyProgram />
            <Payment />
            <PoweredByJusto />
          </>
        }
      >
        <div className="flex flex-col md:p-10 lg:p-20">
          <Logo />
          <div className="py-2">
            <Page slug="/checkout" />
          </div>
          <Main />
          <LoyaltyProgram />
          <Upselling />
        </div>
      </Layout>
      <PreferencesCleaner />
      {!isAnalyticsV2Avail && <TrackPageView />}
      {isAnalyticsV2Avail && <TrackCheckoutPageView />}
    </CheckoutV3ContextProvider>
  )
}
